// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2XD25","content":"styles_content__2dfjh","selectAll":"styles_selectAll__2-cHV"};